import { RightOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import classNames from 'classnames';
import type { ReactNode } from 'react';

import styles from './ExpandableCard.module.scss';

type ExpandableCardProps = {
  sectionTitle: string;
  title: string;
  icon: ReactNode;
  children: ReactNode;
  tag?: string;
  tagLabel?: string;
  errorMessage?: string;
  isExpanded: boolean;
  onToggle: () => void;
};

export const ExpandableCard = ({
  sectionTitle,
  title,
  icon,
  children,
  tag,
  tagLabel,
  errorMessage,
  isExpanded,
  onToggle,
}: ExpandableCardProps) => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.sectionTitle}>{sectionTitle}</p>
      <div
        className={classNames(styles.card, { [styles.expanded]: isExpanded })}
      >
        <div className={styles.container} onClick={onToggle}>
          <div className={styles.leftPart}>
            <div className={styles.iconBox}>{icon}</div>
            <div className={styles.texts}>
              <p className={styles.title}>{title}</p>
            </div>
          </div>

          <div className={styles.rightPart}>
            {tag && tagLabel && !errorMessage && (
              <span className={styles.tagLabel}>{tagLabel}</span>
            )}
            {tag && !errorMessage && <Tag className={styles.tag}>{tag}</Tag>}
            {errorMessage && (
              <span className={styles.errorMessage}>{errorMessage}</span>
            )}
            <span
              className={classNames(styles.arrow, {
                [styles.expand]: isExpanded,
              })}
            >
              <RightOutlined />
            </span>
          </div>
        </div>

        <div
          className={styles.collapse}
          style={{ display: isExpanded ? 'block' : 'none' }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
